var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AppState from '../AppState';
/**
 * Fetches full fibre plans based on given parameters.
 *
 * @param {string} planData - The plan data to be sent in the request body.
 * @param {Address} serviceAddressObject - The address object returned by the SQ.
 * @param {number} sales_idField - The received Sales ID.
 * @param {string} tokenField - The received token.
 * @returns {Promise} - A promise that resolves to object containing the SQ and
 *                      address objects with the sales ID and token.
 * @throws {Error} - If the response is not successful.
 */
const getFullFibrePlans = (planData, serviceAddressObject, sales_idField, tokenField) => {
    const drupalJsObjects = AppState.get('drupalJsObjects');
    const { settings } = drupalJsObjects;
    const { vocusApiRoot, vocusApiFullFibre } = settings;
    const fullFibrePlansEndpoint = vocusApiRoot + vocusApiFullFibre;
    return fetch(fullFibrePlansEndpoint, {
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json',
        },
        body: planData,
    })
        .then((response) => __awaiter(void 0, void 0, void 0, function* () {
        if (!response.ok) {
            throw new Error('It did not work');
        }
        else {
            return {
                onePlatformServiceQualification: false,
                serviceQualification: yield response.json(),
                address: serviceAddressObject,
                salesId: sales_idField,
                token: tokenField,
            };
        }
    }));
};
export default getFullFibrePlans;
